import React from "react";
import { Form } from "antd";
import Select, { components } from "react-select";
const { Option } = Select;
const customStyles = {
  root:base=>({
    ...base,
    marginTop:"5px"
  }),
  control: base => ({
    ...base,
    height: 33,
    minHeight: 30,
    marginTop:"5px"

  }),
  placeholder: base => ({
    ...base,
    color: "#ccc",
    fontSize: 14
  })
};
const UiDropDown = props => {
  const {
    title,
    required,
    value,
    multiple,
    disabled,
    tabIndex,
    validation,
    style,
    size,
    placeholder,
    data,
    onChange,
    className,
    defaultValue
  } = props;
  return (
    <Select
      className={className}
      value={value}
      isMulti={multiple}
      isDisabled={disabled}
      tabIndex={tabIndex}
      defaultValue={defaultValue}
      
      placeholder={placeholder}
      style={style??{}}
      options={data}
      size={size?? "small"}
      styles={customStyles}
      onChange={value => onChange(value)}
      {...props}
    />
  );
};

export default UiDropDown;
